import { request } from "@/utils/request";

// 获取购物车列表
export const queryTotalBuyerCartList = (data) => {
  return request({
    url: "/product/mall/queryTotalBuyerCartList",
    method: "POST",
    data,
  });
};

// 删除购物车记录
export const removeBuyerCart = (data) => {
  return request({
    url: "/product/mall/removeBuyerCart",
    method: "POST",
    data: data,
  });
};

// 拆单接口
export const totalListSplitDemand = (data) => {
  return request({
    url: "/order/public/totalListSplitDemand",
    method: "POST",
    data: data,
  });
};

// 获取默认地址的接口
export const queryUserAddress = (companyId) => {
  return request({
    url: `/user/mall/queryUserAddress?companyId=${companyId}`,
    method: "GET",
  });
};

//购物车获取0元购商品接口
export const getCartPurchaseZero = (params) => {
  return request({
    url: `/order/public/getCartPurchaseZero`,
    method: "POST",
    data: params,
  });
};

// 获取备选地址的接口
export const getAddressList = (data) => {
  return request({
    url: "/user/mall/getAddressList",
    method: "POST",
    data: data,
  });
};

// 提交订单
export const saveAllDemandOrder = (data) => {
  return request({
    url: "/order/public/saveAllDemandOrder",
    method: "POST",
    data: data,
  });
};

// 获取收款方信息
export const getAccountInfo = (data) => {
  return request({
    url: "/cms/mall/account/queryPageByCompanyId",
    method: "POST",
    data: data,
  });
};

// 获取需求单订单变动明细的明细
export const getShoppingCartActivity = (params) => {
  return request({
    url: "/order/mall/getShoppingCartActivity",
    method: "POST",
    data: params,
  });
};

//编辑购物车数量
export const editCartList = (params) => {
  return request({
    url: "/product/mall/modifyBuyerCartQuantity",
    method: "POST",
    data: params,
  });
};

// 首营提交电话接口
export const updatePotentialClientsPhone = (number, ids) => {
  return request({
    url: `/user/public/updatePotentialClientsPhone?phoneNumber=${number}&companyIds=${ids}`,
    method: "GET",
  });
};

// 购物车加入常购清单
export const addOftenList = (params) => {
  return request({
    url: "/product/mall/modifyBuyerCartToFrequentPurchase",
    method: "POST",
    data: params,
  });
};

// 获取终端流向区域
export const getAbbotProjectDistrictMap = (params) => {
  return request({
    url: `/user/public/abbotProjectDistrict/getAbbotProjectDistrictMap`,
    method: "POST",
    data: params,
  });
};
